/**
 * Split nav threads into pinned (ordered by pin list) and unpinned (original order).
 *
 * @template {{ id: string }} T
 * @param {T[]} threads
 * @param {string[]} pinnedThreadIds
 * @returns {{ pinnedThreads: T[]; unpinnedThreads: T[] }}
 */
export function splitNavThreadsByPinned(threads, pinnedThreadIds = []) {
  if (!threads.length || !pinnedThreadIds.length) {
    return { pinnedThreads: [], unpinnedThreads: threads }
  }

  const pinnedSet = new Set(pinnedThreadIds)
  const pinnedThreads = pinnedThreadIds
    .map((id) => threads.find((thread) => thread.id === id))
    .filter(Boolean)
  const unpinnedThreads = threads.filter((thread) => !pinnedSet.has(thread.id))

  return { pinnedThreads, unpinnedThreads }
}
